import { html } from "lit";
import { AnNamElement } from "../../base-element";

export class AnShippingProgress extends AnNamElement {
  static properties = {
    subtotalCents: { type: Number, attribute: "subtotal-cents" },
    thresholdCents: { type: Number, attribute: "threshold-cents" }
  };

  declare subtotalCents: number;
  declare thresholdCents: number;

  constructor() {
    super();
    this.subtotalCents = 0;
    this.thresholdCents = 0;
  }

  render() {
    if (!this.thresholdCents) return html``;

    const progress = Math.min(100, Math.round((this.subtotalCents / this.thresholdCents) * 100));
    const remaining = Math.max(0, this.thresholdCents - this.subtotalCents);
    const message =
      remaining > 0
        ? `Add ${(remaining / 100).toLocaleString("en-AU", { style: "currency", currency: "AUD" })} for free shipping`
        : "You unlocked free shipping";

    return html`
      <div class="an-progress-wrap">
        <div class="an-progress-label">${message}</div>
        <div class="an-progress-track"><div class="an-progress-bar" style="width:${progress}%"></div></div>
      </div>
    `;
  }
}

if (!customElements.get("an-shipping-progress")) {
  customElements.define("an-shipping-progress", AnShippingProgress);
}
